import { Co2MaterialLibrary } from "@api/apiClient";
import i18n from "@i18n/i18n";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { Autocomplete, Checkbox, Chip, ListItem } from "@mui/material";
import TextField from "@mui/material/TextField";
import { observer } from "mobx-react";

export interface MaterialLibrarySelectProps {
  disabled?: boolean;
  options?: Co2MaterialLibrary[];
  value?: Co2MaterialLibrary[];
  onChange?: (event: any, newSelections: Co2MaterialLibrary[]) => void;
}

const MaterialLibrarySelect = observer((props: MaterialLibrarySelectProps) => {
  return (
    <Autocomplete
      limitTags={2}
      multiple
      id="material-library-select"
      options={props.options || []}
      disableCloseOnSelect
      getOptionLabel={(option: any) => option.name}
      renderOption={(props: any, option: any, { selected }: { selected: boolean }) => {
        const { key, ...rest } = props;
        return (
          <ListItem key={props.id} {...rest}>
            <Checkbox icon={<CheckBoxOutlineBlankIcon fontSize="small" />} checkedIcon={<CheckBoxIcon fontSize="small" />} style={{ marginRight: 8 }} checked={selected} />
            {option.name}
          </ListItem>
        );
      }}
      renderTags={(tagValue, getTagProps) => {
        return tagValue.map((option, index) => <Chip {...getTagProps({ index })} key={option.name} label={option.name} />);
      }}
      onChange={(event: any, newSelections: Co2MaterialLibrary[]) => {
        if (props.onChange) {
          props.onChange(event, newSelections);
        }
      }}
      value={props.value || []}
      style={{ width: 500, marginTop: 1 }}
      renderInput={(params: any) => {
        const { key, ...rest } = params;
        return <TextField key={key} {...rest} mt={1} label={i18n.t("material-library-select.label")} placeholder={i18n.t("material-library-select.placeholder")} />;
      }}
      disabled={props.disabled}
    />
  );
});

export default MaterialLibrarySelect;
